import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {interval, Observable} from 'rxjs';
import {AuthenticationService} from "../services";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authenticationService: AuthenticationService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if(this.authenticationService.user === null){
      this.router.navigate(['/']);
      return false;
    }
    if(!!this.authenticationService.user){
      return true;
    }

    const authenticationService = this.authenticationService;
    return new Observable<boolean>((subscriber) => {
      const subscription = authenticationService.userSubject.subscribe((user)=>{
        if (!!authenticationService.user) {
          subscriber.next(true);
          subscription.unsubscribe();
        }

        if (authenticationService.user === null) {
          subscriber.next(false);
          subscription.unsubscribe();
          this.router.navigate(['/']);
        }
      });
    });
  }

}
